export default __webpack_public_path__ + "static/media/markerStop.60c6d275.svg";